export const clearIndicator = (styles, color, fontColor) => ({
    ...styles,
    backgroundColor: '#fff',
    borderRadius: '9999px',
    color: color === '#fff' ? fontColor : color,
    cursor: 'pointer',
    margin: '0 8px 0 5px',
    padding: '0px',
});

export const dropdownIndicator = (styles, state, color, isClearable, fontColor) => {
    const { display } = styles;
    let dropdownIndicatorDisplay = display;
    let dropdownIndicatorColor = fontColor;

    if (isClearable) {
        dropdownIndicatorDisplay = !state.isMulti && state.hasValue ? 'none' : 'visible';
    }

    if (state.selectProps.isLoading) {
        dropdownIndicatorDisplay = 'none';
    }

    if (color !== '#fff') {
        dropdownIndicatorColor = fontColor || '#fff';
    }

    return {
        ...styles,
        color: dropdownIndicatorColor,
        cursor: 'pointer',
        display: dropdownIndicatorDisplay,
        margin: '2px 8px 0 4px',
        padding: '0',

        '&:hover': {
            color: color === '#fff' ? '#261f41' : '#fff',
        },
    };
};

export const indicatorSeparator = (styles, state) => ({
    ...styles,
    display: !state.isMulti ? 'none' : 'visible',
});
